angular
	.module 'App.Directive'
	.directive 'executeOnSubmit', (KEY) ->
		link: (scope, element, attrs) ->
			element.on 'keydown keypress', (event) ->
				if event.which == KEY.ENTER
					scope.$apply -> scope.$eval(attrs.executeOnSubmit)

					event.preventDefault()
